import { useMutation, useQuery } from "@tanstack/react-query";
import { postAuthenticateUser, fetchClientInfo } from "./api";
import { AuthenticateUserRequestType } from "../types";

export function useAuthenticateUser() {
  return useMutation({
    mutationFn: (payload: AuthenticateUserRequestType) =>
      postAuthenticateUser(payload),
  });
}

export function useFetchClientInfo() {
  return useQuery({
    queryKey: ["client"],
    queryFn: () => fetchClientInfo(),
  });
}
